import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ExpenseCheckClaim, ExpenseCheckSubTotal } from 'app/core/models/expense-check.model';
import { ExpenseCategorySelected } from 'app/core/models/expense.model';
import { CheckExpenseClaimListModalComponent } from '../check-expense-claim-list/check-expense-claim-list.component';

@Component({
  selector: 'app-approved-expenses-container',
  templateUrl: './approved-expenses-container.component.html',
  styleUrl: './approved-expenses-container.component.scss'
})
export class ApprovedExpensesContainerComponent {
  @Input() claims: ExpenseCheckClaim[];
  @Input() subTotals: ExpenseCheckSubTotal[];
  @Input() showCheckbox: boolean = false;

  @Output() toggleCategory: EventEmitter<ExpenseCategorySelected> = new EventEmitter<ExpenseCategorySelected>();

  @ViewChild('expenseListModal') expenseListModal: CheckExpenseClaimListModalComponent;

  onCategorySelected(event: any, category: string) {
    this.toggleCategory.emit({ checked: event.target.checked, category: category });
  }

  onExpenseList() {
    this.expenseListModal.show();
  }
}
